import React from 'react';
import type { DispositionSource } from '../types';

/** Disposition source. MANUAL and TATA_TELE count as worked; the other two are automation. */
const STYLE: Record<DispositionSource, { cls: string; counts: boolean }> = {
  MANUAL:    { cls: 'bg-emerald-100 text-emerald-800 border-emerald-200 dark:bg-emerald-400/15 dark:text-emerald-200 dark:border-emerald-400/30', counts: true },
  TATA_TELE: { cls: 'bg-sky-100 text-sky-800 border-sky-200 dark:bg-sky-400/15 dark:text-sky-200 dark:border-sky-400/30', counts: true },
  ENGATI_AI: { cls: 'bg-slate-100 text-slate-700 border-slate-200 dark:bg-slate-400/15 dark:text-slate-200 dark:border-slate-400/30', counts: false },
  SYSTEM:    { cls: 'bg-slate-100 text-slate-700 border-slate-200 dark:bg-slate-400/15 dark:text-slate-200 dark:border-slate-400/30', counts: false },
};

const SourceBadge: React.FC<{ source: string }> = ({ source }) => {
  const s = STYLE[source as DispositionSource];
  if (!s) return <span className="text-slate-600">—</span>;
  return (
    <span
      title={s.counts ? 'Counts as worked' : 'Automation: not counted as worked'}
      className={`inline-flex rounded-full border px-2 py-0.5 text-[11px] font-medium ${s.cls}`}
    >
      {source}
    </span>
  );
};

export default SourceBadge;
